// These enumerations are shared by back and front end. Do not place any code or dependencies here, only enums or constants.

export enum SimpleBoolean {
    No = 0,
    Yes = 1,
}

export enum SimpleDirection {
    'Left To Right' = 1,
    'Right To Left' = -1,
}

export enum SimpleLocationType {
    'Bloc' = -1,
    'Country' = 0,
    'Region' = 1,
    'State' = 2,
    'City' = 3,
    'Place' = 4,
    'Ocean' = 5,
    'Lake' = 6,
    'River' = 7,
    'Island' = 8,
    'Basin' = 9,
    'Mountain' = 10,
}

export enum SimpleApplicationType {
    'N/A' = 0,
    'Allowed' = 1,
    'Required' = 2,
}

export enum SimpleBaseEventType {
    'None' = 0,
    '"To" Only' = 1,
    '"From" Only' = 2,
    'Left to Right' = 3,
    'Right to Left' = 4,
}

export enum SimpleBaseEventTypeSingleOnly {
    'None' = 0,
    '"To" Only' = 1,
    '"From" Only' = 2,
}

// BaseEvent.eventType. A Base event is a generic pattern, exported as baseEvent/14. A Known event is one named
// instance of its parent Base event (a specific hurricane or war), exported as knownEvent/19 with the parent's
// marker as its base event.
export enum BaseEventKind {
    'Base' = 0,
    'Known' = 1,
}

export enum SimpleSuggestionType {
    'Unknown' = 0,
    'Author' = 1,
    'Indicator' = 2,
    'Link' = 3,
    'Event' = 4,
    'Location' = 5,
    'Trend' = 6,
    'Value' = 7,
}

export enum FavorableType {
    'Unfavorable' = -1,
    'Neutral' = 0,
    'Favorable' = 1,
}

export enum SimpleAuthorType {
    'Person' = 0,
    'Institution' = 1,
    'Company' = 2,
    'Publisher' = 3,
}

export enum SimpleUnitType {
    'Unknown' = 0,
    'Currency' = 1,
    'Mass' = 2,
    'Volume' = 3,
    'Length' = 4,
    'Time' = 5,
    'Current' = 6,
    'Temperature' = 7,
    'Force' = 8,
    'Energy' = 9,
    'Power' = 10,
    'Percentage' = 11,
    'Units' = 12,
    'Surface' = 13,
    'Memory' = 14,
}

export enum SimpleStandardMeasure {
    'Unknown' = 0,
    'us dollars' = 1,
    'kgs' = 2,
    'liters' = 3,
    'meters' = 4,
    'seconds' = 5,
    'amps' = 6,
    'degrees celsius' = 7,
    'newtons' = 8,
    'joules' = 9,
    'watts' = 10,
    'points' = 11,
    'objects' = 12,
    'square meters' = 13,
    'megabytes' = 14,
}

export enum ExpandedUnitType {
    'Unknown' = 0,
    'Currency - $USD' = 1,
    'Mass - KGs' = 2,
    'Volume - Liters' = 3,
    'Length - Meters' = 4,
    'Time - Seconds' = 5,
    'Current - Amps' = 6,
    'Temperature - Degrees Celsius' = 7,
    'Force - Newtons' = 8,
    'Energy - Joules' = 9,
    'Power - Watts' = 10,
    'Percentage - Points' = 11,
    'Units - Objects' = 12,
    'Surface Area - Square Meters' = 13,
    '(Digital) Memory - Megabytes' = 14,
}

export enum UntypedType {
    'Untyped' = 0,
    'Executable' = 1,
    'Custom' = 2,
}

export enum FeatureType {
    'Real' = 0,
    'String' = 1,
}

export enum SimpleSign {
    'Negative To Trend' = -2,
    'Negative Correlation' = -1,
    Unknown = 0,
    'Positive Correlation' = 1,
    'Positive To Trend' = 2,
    'Inverted' = 3,
}

export enum SimpleMarkerAssociationType {
    Wikipedia = 0,
    'Iso Url' = 1,
}

export enum SimpleCompanyGroupType {
    'Company' = -1,
    'Product' = -2,
}

export enum SimpleIndustryGroupType {
    'Industry' = 0,
    'Segment' = 1,
}

export const SimpleMarkerAssociationTypeValidation = {
    0: {
        pattern: '^https?\\:\\/\\/([\\w\\.]+)wikipedia.org\\/wiki\\/\\w.*',
        errMsg: 'Url must start with https://&#x3C;lang&#x3E;.wikipedia.org/wiki/ or http://&#x3C;lang&#x3E;.wikipedia.org/wiki/',
    },
    1: { pattern: '^https?\\:\\/\\/www.iso.org\\/\\w.*', errMsg: 'Url must start with https://www.iso.org/ or http://www.iso.org/' },
};

export const blockerTypes = {
    1: { id: 1, name: 'baseKPI', table: 'indicator' },
    2: { id: 2, name: 'baseEvent' },
    3: { id: 3, name: 'location' },
    4: { id: 4, name: 'industry', table: 'industryGroup', type: SimpleIndustryGroupType.Industry },
    5: { id: 5, name: 'company', table: 'companyGroup', type: SimpleCompanyGroupType.Company },
    6: { id: 6, name: 'segment', table: 'industryGroup', type: SimpleIndustryGroupType.Segment },
    7: { id: 7, name: 'product', table: 'companyGroup', type: SimpleCompanyGroupType.Product },
};

export const blockerPlaceholders = {
    1: { id: 1, name: 'X' },
    2: { id: 2, name: 'Y' },
    3: { id: 3, name: 'X' },
    4: { id: 4, name: 'T' },
    5: { id: 5, name: 'XnotY' },
    6: { id: 6, name: 'XnotZ' },
    7: { id: 7, name: 'XnotT' },
    8: { id: 8, name: 'YnotX' },
    9: { id: 9, name: 'YnotZ' },
    10: { id: 10, name: 'YnotT' },
    11: { id: 11, name: 'ZnotX' },
    12: { id: 12, name: 'ZnotY' },
    13: { id: 13, name: 'ZnotT' },
    14: { id: 14, name: 'TnotX' },
    15: { id: 15, name: 'TnotY' },
    16: { id: 16, name: 'TnotZ' },
};

export const blockerValues = {
    1: { id: 1, name: 'Company' },
    2: { id: 2, name: 'Industry' },
    3: { id: 3, name: 'Product' },
    4: { id: 4, name: 'Segment' },
};

export enum sortLevels {
    equal = 1,
    startsWith = 2,
    endsWith = 3,
    allTermsPriority = 4,
    allTermsNoPriority = 5,
}

// An event's components (BaseEvent columns), in the editor's order and in knownEvent/19's, with the BaseEvent columns of
// each component's contexts: toColumn, a Base event's default and a Known event's To context, and fromColumn, a Known
// event's From context. Each entry also gives the marker type a context must be, its subtype for a company group, and
// how a message names it. The industry context may be any industry group, an industry or a segment. Events have no
// Segment component: the analyzer finds none for them, and an event's industry stands for it.
export const eventComponentContexts: {
    component: string, label: string, type: string, subType?: number, description: string, toColumn: string, fromColumn: string,
}[] = [
    { component: 'location', label: 'Location', type: 'location', description: 'a location',
        toColumn: 'locationContext', fromColumn: 'fromLocationContext' },
    { component: 'industry', label: 'Industry', type: 'industryGroup', description: 'an industry or a segment',
        toColumn: 'industryContext', fromColumn: 'fromIndustryContext' },
    { component: 'company', label: 'Company', type: 'companyGroup', subType: SimpleCompanyGroupType.Company, description: 'a company',
        toColumn: 'companyContext', fromColumn: 'fromCompanyContext' },
    { component: 'product', label: 'Product', type: 'companyGroup', subType: SimpleCompanyGroupType.Product, description: 'a product',
        toColumn: 'productContext', fromColumn: 'fromProductContext' },
    { component: 'author', label: 'Author', type: 'author', description: 'an author',
        toColumn: 'authorContext', fromColumn: 'fromAuthorContext' },
];

export const baseEventComponents = eventComponentContexts.map(({ component }) => component);

export const SimpleRegions = [ 'NORTHAM', 'EMEA', 'APAC', 'LATAM' ];

export enum MarkerSort {
    DATE_REVERSE = 'dateReverse',
    DATE = 'date',
    RELEVANCE = 'relevance',
}

export enum MarkerKbNames {
    baseKPI = 'baseKPI',
    timeSpan = 'timeSpan',
    eCLMarker = 'eCLMarker',
    baseEvent = 'baseEvent',
    knownEvent = 'knownEvent',
    location = 'location',
    value = 'value',
    author = 'author',
    trendMarker = 'trendMarker',
    unit = 'unit',
    industryGroup = 'industryGroup',
    companyGroup = 'companyGroup',
    suggestionMarker = 'suggestionMarker',
    compoundUnit = 'compoundUnit',
    composite = 'composite',
    intensity = 'intensity',
    feature = 'feature',
    collection = 'collection',
    title = 'title',
    executable = 'executable',
    untyped = '',
}

export enum MarkerType {
    Author = 'author',
    Indicator = 'indicator',
    CompanyGroup = 'companyGroup',
    IndustryGroup = 'industryGroup',
    Unit = 'unit',
    CompoundUnit = 'compoundUnit',
    ECL = 'ecl',
    Location = 'location',
    Suggestion = 'suggestion',
    Time = 'time',
    Trend = 'trend',
    Value = 'value',
    Untyped = 'untyped',
    Composite = 'composite',
    Intensity = 'intensity',
    Feature = 'feature',
    Collection = 'collection',
    BaseEvent = 'baseEvent',
    Feedback = 'feedback',
}
